/*
 *   Copyright (c) 2021 Sok Channy
 *   All rights reserved.
 */
import React, { useState, useEffect } from 'react';
import { Route, Switch, Redirect } from "react-router-dom";
import { Routes } from "../routes";

// pages
import Presentation from "./Presentation";
import Upgrade from "./Upgrade";
import DashboardOverview from "./dashboard/DashboardOverview";

import Settings from "./Settings";
import BootstrapTables from "./tables/BootstrapTables";
import Signup from "./examples/Signup";
import ForgotPassword from "./examples/ForgotPassword";
import ResetPassword from "./examples/ResetPassword";
import Lock from "./examples/Lock";
import NotFoundPage from "./examples/NotFound";
import ServerError from "./examples/ServerError";

// components
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Preloader from "../components/Preloader";

import SigninPage from './signin/SigninPage';
import WaybillPage from './waybills/WaybillPage';
import WaybillArrived from './waybills/WaybillArrivedPage';
import WaybillImportPage from './waybills/WaybillImportPage';
import WaybillScanPage from './waybill_scans/WaybillScanPage'

import ReceiverPage from './users/ReceiverPage';
import ReceiverAddressPage from './users/ReceiverAddressPage';
import SystemUserPage from './system/SystemUserPage';
import Transactions from "./transaction/TransactionPage";
import BundleSheetPage from './transaction/BundleSheetPage';

import SystemSettingPage from './setting/SystemSettingPage';

import { ASYNC_KEY } from '../core/util/General';
import { getUser } from '../core/auth/authentication';


const RouteWithLoader = ({ component: Component, ...rest }) => {
  const [loaded, setLoaded] = useState(false);
  
  useEffect(() => {
    //const timer = setTimeout(() => setLoaded(true), 1000);
    //return () => clearTimeout(timer);
  }, []);

  return (
    // <Route {...rest} render={props => ( <> <Preloader show={loaded ? false : true} /> <Component {...props} /> </> ) } />
    <Route {...rest} render={props => ( <> <Component {...props} /> </> ) } />
  );
};

const RouteWithSidebar = ({ component: Component, ...rest }) => {
  const [loaded, setLoaded] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState('ckecking')  
  
  useEffect(() =>  {
    async function checkLogin() {
      const check = await localStorage.getItem(ASYNC_KEY.IS_LOGIN)
      setIsAuthenticated(check)    
    }
    checkLogin()    
  }, [])

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  const localStorageIsSettingsVisible = () => {
    return localStorage.getItem('settingsVisible') === 'false' ? false : true
  }

  const [showSettings, setShowSettings] = useState(localStorageIsSettingsVisible);

  const toggleSettings = () => {
    setShowSettings(!showSettings);
    localStorage.setItem('settingsVisible', !showSettings);
  }

  
    return (
      isAuthenticated == 'ckecking' ? <></> : (isAuthenticated == 'true' ?
      <Route {...rest} render={props => (
        <>
          <Preloader show={loaded ? false : true} />
          <Sidebar />
  
          <main className="content">
            <Navbar />
            <Component {...props} />
            <br/><br/>
            <br/>
            <Footer/>
            {/* <Footer toggleSettings={toggleSettings} showSettings={showSettings} /> */}
          </main>
        </>
      )}
      /> : <SigninPage />)
    );
  

};

export default () => {

  const [user, setUser] = useState()
  useEffect(()=> {
    getUser().then(it=>{
      setUser(it)
    })
  }, [])

  return (
    <Switch>
  
    {/* <RouteWithLoader exact path={Routes.Presentation.path} component={Presentation} /> */}
    
    <RouteWithLoader exact path={Routes.Signup.path} component={Signup} />
    <RouteWithLoader exact path={Routes.ForgotPassword.path} component={ForgotPassword} />
    <RouteWithLoader exact path={Routes.ResetPassword.path} component={ResetPassword} />
    <RouteWithLoader exact path={Routes.Lock.path} component={Lock} />
    <RouteWithLoader exact path={Routes.NotFound.path} component={NotFoundPage} />
    <RouteWithLoader exact path={Routes.ServerError.path} component={ServerError} />
    
    {/* HUB PAGE */}
    <RouteWithLoader exact path={Routes.Signin.path} component={SigninPage} />
    
    <RouteWithSidebar exact path={Routes.Waybill.path} component={WaybillPage} />
    <RouteWithSidebar exact path={Routes.arrived.path} component={WaybillArrived} />
    <RouteWithSidebar exact path={Routes.WaybillImport.path} component={ _.get(user, 'role') == 'Super Admin' ? WaybillImportPage : BlankPage} />   
    <RouteWithSidebar exact path={Routes.WaybillScan.path} component={WaybillScanPage} />   


    <RouteWithSidebar exact path={Routes.Receiver.path} component={ReceiverPage} />   
    <RouteWithSidebar exact path={Routes.ReceiverAddress.path} component={ReceiverAddressPage} />   

    <RouteWithSidebar exact path={Routes.BundleSheet.path} component={(_.get(user, 'role') == 'Super Admin' || (_.get(user, 'role') == 'Admin' && _.get(user, 'countryCode') == 855)) ? BundleSheetPage : BlankPage } />
    <RouteWithSidebar exact path={Routes.Transactions.path} component={ _.get(user, 'role') == 'Super Admin' ? Transactions : BlankPage } />   


    <RouteWithSidebar exact path={Routes.SystemUser.path} component={  _.get(user, 'role') == 'Super Admin' ? SystemUserPage : BlankPage} />
    <RouteWithSidebar exact path={Routes.SystemSetting.path} component={  _.get(user, 'role') == 'Super Admin' ? SystemSettingPage : BlankPage} />

    
    <RouteWithSidebar exact path={Routes.DashboardOverview.path} component={DashboardOverview} />    
    
    <RouteWithSidebar exact path={Routes.Settings.path} component={ _.get(user, 'role') == 'Super Admin' ? Settings : BlankPage} />
    

    <Redirect to={Routes.NotFound.path} />
  </Switch>
  )
}


const BlankPage = (props) => {
  return <></>
}